import { usePlacesStore,useMapStore } from "@/composables";
import { defineComponent, ref, onMounted, watch } from 'vue';
import Mapboxgl from "mapbox-gl";


export default defineComponent({
    name: 'MapView',
    setup() {
        const mapElement = ref<HTMLDivElement>()
        const { isLoading, userLocation, isUserlocationReady } = usePlacesStore()
        const { setMap } = useMapStore()
        const initMap = async () => {
            if( !mapElement.value) throw new Error('Div element no existe')
            if( !userLocation.value) throw new Error('User Location no existe')

            await Promise.resolve()

            const map = new Mapboxgl.Map({
                container: mapElement.value, // container ID
                style: 'mapbox://styles/mapbox/streets-v12', // style URL
                // style: 'mapbox://styles/mapbox/light-v10', // style URL
                // style: 'mapbox://styles/mapbox/dark-v10', // style URL
                center: userLocation.value, // starting position [lng, lat]
                zoom: 15, // starting zoom
            });

            const myLocationPopUp = new Mapboxgl.Popup()
            .setLngLat( userLocation.value )
            .setHTML( `
            <h4>Aqui estoy</h4>
            <p>Actualmente en Logroño</p>
            <p>${userLocation.value}</p>
            `)
            

            const myLocaltionMarker = new Mapboxgl.Marker()
                .setLngLat( userLocation.value )
                .addTo(map)
                .setPopup(myLocationPopUp)

            setMap( map)
            
        } 

        onMounted ( () => {
            console.log(mapElement.value)
            if ( isUserlocationReady.value)
                return initMap()
            console.log('No tengo localizacion aun')
        } ) 

        watch( isUserlocationReady, (newVal) => {
            if( isUserlocationReady.value ) initMap()
        })

        return {
            isLoading, userLocation, isUserlocationReady, mapElement

        }
    }
})